<app-layout>
<h1 class="mb-8 font-bold text-3xl">Market Liquidity</h1>
<div class="bg-white rounded shadow overflow-x-auto">
    <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">Name</th>
            <th class="px-6 pt-6 pb-4">Status</th>
            <th class="px-6 pt-6 pb-4">Actions</th>
        </tr>
        <tr v-for="market in markets.data" :key="market.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
                <span class="px-6 py-4 flex items-center">
                    {{ market.name }}
                </span>
            </td>
            <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" v-if="!market.deleted_at" :type="market.status ? 'green' : 'gray'">
                            {{ market.status ? 'Active' : 'Hidden' }}
                        </badge>

                        <badge v-if="!market.deleted_at" :type="market.trade_status ? 'green' : 'red'">
                            {{ market.trade_status ? 'Tradable' : 'Not Tradable' }}
                        </badge>
                    </span>
            </td>
            <td class="border-t">
                <nav-button v-if="market.status && !market.deleted_at && !activeMarkets[market.name]" :class="{ 'opacity-75': sending ==  market.id}" @click.native="runLiquidity(market)">
                    <svg v-show="sending ==  market.id" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Run liquidity</span>
                </nav-button>

                <nav-button-active v-if="activeMarkets[market.name]" @click.native="stopLiquidity(market)">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Stop liquidity</span>
                </nav-button-active>
            </td>
        </tr>
        <tr v-if="markets.data.length === 0">
            <td class="border-t px-6 py-4" colspan="100">No markets found.</td>
        </tr>
    </table>
</div>
<pagination :links="markets.links" />
</app-layout>
